import { StyleSheet, View } from '../../compiler'
import { colors, typoStyles } from '../../constants'
import MarkdownText from '../MarkdownText'

const styles = StyleSheet.create({
  headerContainer: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderWidth: 1,
    borderColor: '#EBF0F5',
    height: 72,
    paddingHorizontal: 24,
    alignItems: 'center'
  },
  contentContainer: {
    borderColor: '#EBF0F5',
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    paddingVertical: 16
  },
  listItemContainer: {
    paddingHorizontal: 24,
    flexDirection: 'row',
    alignItems: 'center'
  },
  numberContainer: {
    height: 40,
    width: 40,
    borderRadius: 20,
    borderWidth: 2,
    borderColor: colors.primaryBlue,
    alignItems: 'center',
    justifyContent: 'center'
  }
})

const TopInterests = ({
  containerStyle = {},
  title,
  data,
  insight,
  withDimensionDescription = false
}) => (
  <View style={containerStyle}>
    <View style={styles.headerContainer}>
      <MarkdownText
        style={[typoStyles.H4Black, { textTransform: 'uppercase' }]}
      >
        {title}
      </MarkdownText>
    </View>
    <View style={styles.contentContainer}>
      {data.map((interest, index) => (
        <View
          key={index}
          style={[
            styles.listItemContainer,
            withDimensionDescription
              ? { height: 'auto', width: '92%', paddingBottom: 12 }
              : { height: 72 }
          ]}
        >
          <View style={{ paddingRight: withDimensionDescription ? 24 : 12 }}>
            <View style={styles.numberContainer}>
              <MarkdownText style={typoStyles.T1Blue}>{`0${
                index + 1
              }`}</MarkdownText>
            </View>
          </View>
          <View>
            <MarkdownText style={typoStyles.H4Black}>
              {interest.title}
            </MarkdownText>
            {withDimensionDescription && (
              <MarkdownText
                style={[
                  typoStyles.T1Black,
                  { color: colors.rockGrey, marginTop: 4, display: 'block' }
                ]}
              >
                {interest.description}
              </MarkdownText>
            )}
          </View>
        </View>
      ))}
    </View>
    <View
      style={{
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        backgroundColor: colors.lightPaleGrey,
        borderBottomWidth: 1,
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderColor: colors.lightGrey,
        padding: 24
      }}
    >
      <MarkdownText style={typoStyles.T1Black}>{insight}</MarkdownText>
    </View>
  </View>
)

export default TopInterests
